// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"sn-z","badgeLink":"tn-z","category":"un-z"};